package main.kotlin.data

data class LoginRequest(val email:String="",val pwd:String="")

data class ResetPasswordRequest(val email:String="")

data class ChangePasswordRequest(val pwd:String="")
